import Vue from 'vue';

Vue.filter('addComma', function (string) {
  if (!string) return "";
  return string.concat(",")
});